import React from "react";
import "./Titlebar.css";

const Titlebar = () => (
    <header className="titlebar-container">
        <h1 className="titlebar-title">The Buzzword Bingo</h1>
    </header>
);

export default Titlebar;
